const indexItems = [
  { title: '电视剧', desc: '热播剧集实时更新', icon: 'ri-tv-line', count: '3,200+部' },
  { title: '电影', desc: '院线大片高清看', icon: 'ri-film-line', count: '8,500+部' },
  { title: '动漫', desc: '国漫日漫全覆盖', icon: 'ri-emotion-line', count: '2,100+部' },
  { title: '综艺', desc: '热门综艺随心刷', icon: 'ri-live-line', count: '1,600+部' },
  { title: '纪录片', desc: '探索未知新世界', icon: 'ri-earth-line', count: '900+部' },
  { title: '少儿', desc: '安全放心成长陪伴', icon: 'ri-parent-line', count: '1,200+部' },
  { title: '短剧', desc: '碎片时间精彩不停', icon: 'ri-smartphone-line', count: '5,000+集' },
  { title: '体育', desc: '赛事集锦燃情回看', icon: 'ri-run-line', count: '3,800+段' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          分类导航
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          八大频道，精准找到你想看的内容
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-200 cursor-pointer group"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="mt-3 text-sm font-heading font-semibold text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-400">{item.desc}</p>
              <span className="inline-block mt-2 text-xs text-primary-500 font-medium bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}